module.exports = __webpack_public_path__ + "../front/img/568_bøjlestang+2hylder.77fed28c.svg";